import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import MenuItem from "@mui/material/MenuItem";

import GridItem from "../../../../componentsv2/GridItem";
import { ModalForm } from "../../../../componentsv2/ModalForm";
import { Input } from "../../../../componentsv2/Input";

import { Context } from "../../../../Context/PermissoesContext";

import { api } from "../../../../services/Api";

const TIPOS_ATENDIMENTO = ["PROCEDIMENTO", "MEDICAMENTO", "ADICIONAL", "DESLOCAMENTO"];

export default function ModalProcedimento ({ open, onClose, procedimento = null }) {
  const [nome, setNome] = useState("");
  const [precoExame, setPrecoExame] = useState(null);
  const [descricao, setDescricao] = useState("");
  const [tipo, setTipo] = useState("PROCEDIMENTO");
  const { enqueueSnackbar } = useSnackbar();
  const { checarPermissao } = useContext(Context);

  useEffect(() => {
    if (!open) {
      return;
    }

    if (procedimento) {
      setNome(procedimento.nome || "");
      setPrecoExame(procedimento.precoExame ?? null);
      setDescricao(procedimento.descricao || "");
      setTipo(procedimento.tipo || "PROCEDIMENTO");
      return;
    }

    setNome("");
    setPrecoExame(null);
    setDescricao("");
    setTipo("PROCEDIMENTO");
  }, [open, procedimento]);

  const onSubmit = async event => {
    event.preventDefault();

    const payload = {
      nome,
      precoExame,
      descricao,
      tipo,
    };

    try {
      if (procedimento?.id) {
        await api.put(`/v2/agendaCare/procedimento/${procedimento.id}`, payload);
      } else {
        await api.post("/v2/agendaCare/procedimento", payload);
      }
      onClose();
    } catch (error) {
      enqueueSnackbar("Erro ao salvar atendimento!", { variant: "error" });
    }
  };

  return (
    <ModalForm
      onSubmit={onSubmit}
      open={open}
      onClose={onClose}
      title={procedimento?.id ? "Editar Atendimento" : "Adicionar Atendimento"}
    >
      <GridItem xs={6}>
        <Input
          required
          fullWidth
          onChange={e => {
            setNome(e.target.value);
          }}
          value={nome}
          label="Nome"
          type="text"
          variant="standard"
        />
      </GridItem>
      <GridItem xs={6}>
        <Input
          select
          required
          fullWidth
          value={tipo}
          label="Tipo"
          variant="standard"
          onChange={event => setTipo(event.target.value)}
        >
          {TIPOS_ATENDIMENTO.map(valor => (
            <MenuItem key={valor} value={valor}>
              {valor}
            </MenuItem>
          ))}
        </Input>
      </GridItem>
      {checarPermissao("AGC002") &&
      <GridItem xs={6}>
        <Input
          required
          fullWidth
          onChange={e => {
            setPrecoExame(e.target.value);
          }}
          value={precoExame}
          label="Valor"
          type="number"
          variant="standard"
        />
      </GridItem>
      }
      <GridItem xs={12}>
        <Input
          onChange={e => {
            setDescricao(e.target.value);
          }}
          value={descricao}
          fullWidth
          label="Descrição"
          type="text"
          variant="standard"
          multiline
          maxRows={5}
        />
      </GridItem>
    </ModalForm>
  );
}
